var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oeamtc-tab__panel",attrs:{"tabindex":"0","role":"tabpanel"}},[_c('div',{staticClass:"oeamtc-panel__indent"},[_vm._v(" "+_vm._s(_vm.headerText)+" ")]),_c('div',{staticClass:"oeamtc-panel__indent"},[_c('fieldset',{staticClass:"oeamtc-fieldset"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }